import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/icons/sticker_text.svg'
import _imports_1 from '../assets/icons/sticker.svg'


const _hoisted_1 = { class: "relative h-220px w-220px" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("img", {
      src: _imports_0,
      class: "absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 z-4 w-58/220 h-70/220"
    }, null, -1),
    _createElementVNode("img", {
      src: _imports_1,
      class: "h-full w-full spin_sticker"
    }, null, -1)
  ])))
}